/**
 * Collection Feature - Local Types & Helpers
 * Format helpers and status mapping for collection views
 */

// ─── Format Helpers ──────────────────────────────────────────────────────────

export const formatCurrencyMXN = (value: number): string =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);

export const formatPercentage = (value: number): string =>
  `${value.toFixed(1)}%`;

// ─── Status → Badge Variant Mapping ─────────────────────────────────────────
// CollectionRecord.collection_status is a plain string: "FULL" | "PARTIAL" | "NONE"

export const COLLECTION_STATUS_VARIANT: Record<string, string> = {
  FULL: 'success',
  PARTIAL: 'warning',
  NONE: 'danger',
};

export const COLLECTION_STATUS_LABEL: Record<string, string> = {
  FULL: 'Cobrado',
  PARTIAL: 'Parcial',
  NONE: 'Sin cobro',
};

// ─── Payment Type → Badge Mapping ───────────────────────────────────────────
// CollectionRecord.payment_type: "REGULAR" | "ANTICIPATED" | "ADVANCED" | "SETTLEMENT"

export const PAYMENT_TYPE_LABEL: Record<string, string> = {
  REGULAR: 'Regular',
  ANTICIPATED: 'Anticipado',
  ADVANCED: 'Adelantado',
  SETTLEMENT: 'Liquidacion',
};

export const PAYMENT_TYPE_VARIANT: Record<string, string> = {
  REGULAR: 'default',
  ANTICIPATED: 'info',
  ADVANCED: 'warning',
  SETTLEMENT: 'success',
};

// ─── Delinquency Week Range Labels ──────────────────────────────────────────
// by_weeks keys are week-range strings: "1-2", "3-4", "5-6", "7+"

export const WEEK_RANGE_LABEL: Record<string, string> = {
  '1-2': '1-2 semanas',
  '3-4': '3-4 semanas',
  '5-6': '5-6 semanas',
  '7+': '7+ semanas',
};

export const WEEK_RANGE_VARIANT: Record<string, string> = {
  '1-2': 'warning',
  '3-4': 'warning',
  '5-6': 'danger',
  '7+': 'danger',
};

// ─── Defaulted / Latent Credit Status Labels ────────────────────────────────

export const DEFAULTED_STATUS_LABEL: Record<string, string> = {
  DEFAULTED: 'En Default',
  IN_COLLECTION: 'En cobranza',
  PARTIALLY_COLLECTED: 'Parcial',
  COLLECTED: 'Cobrado',
  WRITTEN_OFF: 'Castigado',
};

export const DEFAULTED_STATUS_VARIANT: Record<string, string> = {
  DEFAULTED: 'danger',
  IN_COLLECTION: 'warning',
  PARTIALLY_COLLECTED: 'info',
  COLLECTED: 'success',
  WRITTEN_OFF: 'default',
};
